import { type TranslationSchema } from '~/locales/resources'

export const resultViewerTypes = ['individual', 'sequential'] as const

export type ResultViewerType = (typeof resultViewerTypes)[number]

export const resultViewerTypeLabelI18nKeyMap = {
  sequential: 'show_table_only',
  individual: 'show_tables_graphs',
} as const satisfies Record<ResultViewerType, keyof TranslationSchema>
